import Vue from 'vue'
import Router from 'vue-router'
import HomeSlider from '@/components/pages/HomeSlider'
import Archive from '@/components/pages/Archive'
import Contact from '@/components/pages/Contact'
import Office from '@/components/pages/Office'
import AdminMain from '@/components/pages/admin/AdminMain'
import Login from '@/components/pages/admin/Login'
import AdminSlides from '@/components/pages/admin/AdminSlides'
import AdminPersons from '@/components/pages/admin/AdminPersons'
import AdminCategories from '@/components/pages/admin/AdminCategories'
import AdminUsers from '@/components/pages/admin/AdminUsers'
import AdminEntries from '@/components/pages/admin/AdminEntries'
import AdminPages from '@/components/pages/admin/AdminPages'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'HomeSlider',
      component: HomeSlider
    },
    {
      path: '/archive',
      name: 'Archive',
      component: Archive
    },
    {
      path: '/archive/:id',
      name: 'ArchiveEntry',
      component: Archive
    },
    {
      path: '/office',
      name: 'Office',
      component: Office
    },
    {
      path: '/contact',
      name: 'Contact',
      component: Contact
    },
    {
      path: '/admin',
      component: AdminMain,
      children: [
        {
          path: '',
          name: 'Login',
          component: Login
        },
        {
          path: 'users',
          name: 'AdminUsers',
          component: AdminUsers
        },
        {
          path: 'slides',
          name: 'AdminSlides',
          component: AdminSlides
        },
        {
          path: 'persons',
          name: 'AdminPersons',
          component: AdminPersons
        },
        {
          path: 'categories',
          name: 'AdminCategories',
          component: AdminCategories
        },
        {
          path: 'entries',
          name: 'AdminEntries',
          component: AdminEntries
        },
        {
          path: 'pages',
          name: 'AdminPages',
          component: AdminPages
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js